import { z } from 'zod';

import { EmailSchema } from '@vestigas/utils';

export const zodStartProcessFromFilesRequestParametersSchema = z.object({
  aiModelId: z.uuid().nullable(),
  dryRun: z.boolean().prefault(true),
  files: z.array(z.instanceof(File)), // 'pdf' | 'xml' | 'json';
  senderAddress: EmailSchema.nullable(),
});
